/* eslint-disable @typescript-eslint/no-unused-vars */
import { WebPlugin } from '@capacitor/core';
export class FirebaseStorageWeb extends WebPlugin {
    watchFileCreation(_options) {
        throw new Error('Method not implemented.');
    }
    deleteFile(_options) {
        throw new Error('Method not implemented.');
    }
    async uploadFile(_options) {
        throw new Error('Method not implemented.');
    }
    async getDownloadUrl(_options) {
        throw new Error('Method not implemented.');
    }
}
//# sourceMappingURL=web.js.map